import { initializeAuth } from "../libraries/_modules/auth0";

import("../libraries/_utilities/lib");
import(/* webpackPrefetch: 1 */ "lazysizes");
import(/* webpackPrefetch: 2 */ "../libraries/_modules/tracking/");
// import(/* webpackPrefetch: 3 */ '../libraries/core');
import(/* webpackPrefetch: 4 */ "../libraries/_modules/AlpineModules");
import(/* webpackPrefetch: 5 */ "alpinejs");
import(/* webpackPrefetch: 6 */ "../libraries/_modules/auth0");

setTimeout(() => {
  initializeAuth();
}, 1200);
